import type { IconSize } from './Icon.vue';
import SphIcon from './Icon.vue';

export { SphIcon };
export type { IconSize };
export default SphIcon;
